<template>
  <div class="wrapper">
    <a class="twitter-timeline" href="https://twitter.com/MatsuyaTori" data-tweet-limit="3">Tweets by MatsuyaTori</a>

    <div class="btn-wrap">
      <a href="https://twitter.com/share?url=https://toriyasaimiso.jp/special/&text=%e6%bc%ab%e7%94%bb%e5%ae%b6%e3%83%bb%e6%9d%b1%e6%9d%91%e3%82%a2%e3%82%ad%e3%82%b3%e5%85%88%e7%94%9f%e6%8f%8f%e3%81%8d%e4%b8%8b%e3%82%8d%e3%81%97%e3%80%8c%e7%a7%81%e3%81%a8%e3%81%a8%e3%82%8a%e9%87%8e%e8%8f%9c%e3%81%bf%e3%81%9d%e3%80%8d%e3%82%a8%e3%83%83%e3%82%bb%e3%82%a4%e6%bc%ab%e7%94%bb%e3%81%8c%e8%aa%ad%e3%82%81%e3%82%8b%ef%bc%81%e3%81%be%e3%81%a4%e3%82%84%20%e3%81%a8%e3%82%8a%e9%87%8e%e8%8f%9c%e3%81%bf%e3%81%9d%e3%82%b9%e3%83%9a%e3%82%b7%e3%83%a3%e3%83%ab%e3%82%b5%e3%82%a4%e3%83%88" onclick="window.open(this.href, 'TWwindow', 'width=650, height=450, menubar=no, toolbar=no, scrollbars=yes'); ga('send', 'event', 'link', 'share', 'tweetshare'); return false; return false;"><img src="../assets/images/btn_twitter.svg" alt="ツイート"></a>
      <a href="https://www.facebook.com/sharer.php?u=https://www.toriyasaimiso.jp/special/" onclick="window.open(this.href, 'FBwindow', 'width=650, height=450, menubar=no, toolbar=no, scrollbars=yes'); ga('send', 'event', 'link', 'share', 'fbshare'); return false;"><img src="../assets/images/btn_facebook.svg" alt="シェア"></a>
    </div>
  </div>
</template>

<script>
  import Tweet from 'vue-tweet-embed'

  export default {
    name: 'Twitter',

    components: {
      Tweet
    },

    metaInfo: {
      script: [
        { src: '//platform.twitter.com/widgets.js' }
      ]
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";

  .wrapper {
    max-width: 550px;
    margin: 35px auto;

    @include media( sm ) {
      margin: 50px auto 0;
    }
  }

  .btn-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    @include media(sm) {
      flex-direction: row;
      justify-content: space-between;
    }

    a {
      display: block;
      margin-top: 25px;
      width: 50vw;
      max-width: 250px;

      @include media(sm) {
        margin: 25px 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Twitter.vue?75c47eb4